import { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { useRef } from 'react';
import { isNullOrEmpty } from '../../../helpers/ObjectHelpers';
import { getElementById } from '../../../helpers/ElementHelpers';
import { Loader } from '@progress/kendo-react-indicators';
import uuid from 'react-uuid';

export default function Busy({
    isBusy = false,
    text = "",
    type = "",
    showSpinner = true,
    blurTimeout = 2000,
    size = "large"
}) {

    const componentRef = useRef({
        timer: null
    });
    const { current: localRef } = componentRef;
    const [guid] = useState(uuid());

    useEffect(() => {
        return (() => {
            onRemove();
        })
    }, [])

    useEffect(() => {
        const body = document.querySelector("body");
        if (!body) return;

        if (!isBusy) {
            onRemove();
        } else {
            const overlay = document.createElement("div");
            overlay.id = guid;
            overlay.className = "overlay";
            overlay.onclick = onClick;

            body.insertAdjacentElement("beforeend", overlay);

            localRef.timer = setTimeout(() => {
                overlay?.classList.add("overlay-active");
            }, blurTimeout);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isBusy]);

    return (
        isBusy && 
        <>
            <div className="overlay-content" onClick={onClick}>
                <div style={{
                    background: isNullOrEmpty(text) ? "transparent" : "var(--busy-overlay-content-bg)"
                }}>
                    {
                        showSpinner &&
                        <div className="overlay-busy-spinner">
                            <BusySpinner type={type} size={size} />
                        </div>
                    }
                    {
                        !isNullOrEmpty(text) &&
                        <div>{parse(text)}</div>
                    }
                </div>
            </div>
        </>
    );

    function onClick() {
        clearTimeout(localRef.timer);

        const overlay = getElementById(guid);
        if (!overlay) return;
        overlay.classList.add("overlay-active");
    }

    function onRemove() {
        clearTimeout(localRef.timer);
        const overlay = getElementById(guid);
        overlay?.remove();
    }
}

export const BusySpinner = ({ type = "pulsing", size = "large" }) => {
    return (
        <Loader type={type} size={size} className="loader-spinner" />
    )
}

export const BusySpinnerContent = ({ type = "", dimensions = 150 }) => {
    return (
        <div className="busy-spinner-content">
            <BusySpinner type={type} dimensions={dimensions} />
        </div>
    )
}
